import React from 'react'
import { Translation } from 'react-i18next'
import CIcon from '@coreui/icons-react'
import { cilNotes } from '@coreui/icons'
import { CNavItem, CNavTitle } from '@coreui/react-pro'

const _nav = [
  // {
  //   component: CNavTitle,
  //   name: <Translation>{(t) => t('SidebarTitle.Administration')}</Translation>,
  // },
  // {
  //   component: CNavItem,
  //   name: <Translation>{(t) => t('AdminDashboard.pageTitle')}</Translation>,
  //   href: '/admin-overview',
  //   icon: <CIcon icon={cilSettings} customClassName='nav-icon' />,
  // },
  // {
  //   component: CNavTitle,
  //   name: <Translation>{(t) => t('TenderDetailView.pageTitle')}</Translation>,
  // },
]

export default _nav
